/**
 * OIDC Callback (Authentik, issue #6). Verarbeitet die Rückleitung nach dem
 * Login (Authorization Code + PKCE) und leitet dann zur App weiter.
 * Wird nur gerendert, wenn OIDC konfiguriert ist.
 *
 * Registrierte Redirect-URI am Authentik-Provider: <origin>/callback
 */

import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"

import { getUserManager, useOidcStore } from "@/lib/oidc"

export default function Callback() {
  const navigate = useNavigate()
  const setOidcUser = useOidcStore((s) => s.setOidcUser)
  const setLoading = useOidcStore((s) => s.setLoading)
  const [error, setError] = useState<string | null>(null)
  // StrictMode guard — signinRedirectCallback darf nur EINMAL laufen
  // (der Authorization Code ist einmalig einlösbar).
  const ranRef = useRef(false)

  useEffect(() => {
    if (ranRef.current) return
    ranRef.current = true

    getUserManager()
      .signinRedirectCallback()
      .then((user) => {
        setOidcUser(user)
        setLoading(false)
        // Zurück an den Ort, von dem die Anmeldung ausging (signIn merkt ihn
        // sich im state) — sonst landet man immer auf der Startseite.
        const zurueck = (user.state as { returnTo?: string } | undefined)?.returnTo
        navigate(zurueck && zurueck.startsWith("/") ? zurueck : "/", { replace: true })
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : "Anmeldung fehlgeschlagen.")
      })
  }, [navigate, setOidcUser, setLoading])

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-2 text-muted-foreground">
        <p>Anmeldung fehlgeschlagen: {error}</p>
        <a className="text-primary underline" href="/login">
          Erneut versuchen
        </a>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen items-center justify-center text-muted-foreground">
      Anmeldung wird abgeschlossen…
    </div>
  )
}
